import { render, staticRenderFns } from "./ShareBar-co.vue?vue&type=template&id=781277c8"
import script from "./ShareBar-co.vue?vue&type=script&lang=js"
export * from "./ShareBar-co.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports